import React, { useEffect } from "react";
import { Dashboard } from "@frameworks/web/components/Reports/Dashboard/Dashboard";
import { ERports } from "@adapters/presenters/action-interfaces/Reports/DashboardSummary";
import di from "@frameworks/web/components/Reports/HoldingReports/di/servicelocator";
import { useSelector } from "react-redux";
import familyDi from "@frameworks/web/components/Reports/FamilyTagging/di/servicelocator";
const HoldingDashboard = ({ setHeadingName }) => {
    const holdingPoweredDashboard = useSelector((state) => state.dashboardSummary.holdings);
    const { IsSummarize: IsSummarize } = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.holdingReport) === null || _a === void 0 ? void 0 : _a.data; });
    useEffect(() => {
        familyDi.familyTagging.setStopFamilyAPICall(true);
        return () => {
            di.holdingReport.getDashboardStreamData(false);
        };
    }, []);
    return (holdingPoweredDashboard.summary && (React.createElement(Dashboard, { isRealisedGainPresent: false, summary: holdingPoweredDashboard.summary, reportName: ERports.HOLDINGS, setSummary: (IsSummarize) => di.holdingReport.getSummarizeHoldingReportData(IsSummarize), enableSummary: IsSummarize, getDashboardData: (fromDate, toDate, isFamily, accountIds) => {
            let payload = {
                isFamily: isFamily,
                accountIds: accountIds,
            };
            di.holdingReport.getDashboardData(payload);
        }, setHeadingName: setHeadingName })));
};
export default HoldingDashboard;
